// ./client/src/utils/htmlToText.js
// Converts email-template HTML into plain text with real spaces and characters.
// Handles both named entities (&amp;, &nbsp;) and numeric ones (&#39;, &#x27;).
const decodeEntities = (value) => {
  if (!value) return "";
  const el = document.createElement("textarea");
  el.innerHTML = value;
  return el.value;
};

const htmlToText = (html) => {
  if (!html) return "";
  return decodeEntities(
    String(html)
      // block-level tags and breaks become a newline so paragraphs survive
      .replace(/<\s*(br|\/p|\/div|\/li|\/tr|\/h[1-6])[^>]*>/gi, "\n")
      // any other tag becomes a space (prevents words running together)
      .replace(/<[^>]*>/g, " "),
  )
    // collapse runs of spaces/tabs, trim each line
    .split("\n")
    .map((line) => line.replace(/[ \t\u00A0]+/g, " ").trim())
    // drop empty lines left by tag stripping, rejoin with newlines
    .filter(Boolean)
    .join("\n");
};

export default htmlToText;